import axios from 'axios';
import router from '../router';
import verify from "./tool";
import global from "./common";
import {
  Toast,
  Dialog
} from 'vant';
import store from '@/store/index';
const service = axios.create({
  baseURL: global.url + "soft",
  // timeout: 20000,
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token        
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
    const token = store.state.token;
    config.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.error(error);
  });
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    // 否则的话抛出错误
    if (response.status === 200) {
      //处理版本更新问题
      switch (response.data.scode) {
        case 600: //版本更新完成
          if (localStorage.getItem("versionTime") == null || (localStorage.getItem("versionTime") !== response.data.version)) {
            localStorage.setItem("versionTime", response.data.version);
            //匹配本地版本缓存是否与后台返回缓存一致，如果一致说明用户已更新过版本，反之需要刷新页面
            Dialog.alert({
              message: '版本已更新完成,数据将自动刷新',
            }).then(() => {
              //刷新当前页面
              location.reload();
            });
          }
          break;
        case 601: //版本更新中,阻止用户使用商城
          Dialog.alert({
            message: response.data.message, //response.data.msg版本更新内容,response.data.version更新版本
          }).then(() => {
            verify.closePage(); //退出系统
          });
          break;
        case 602: //版本更新预告
          if (localStorage.getItem("versionTime") == null || (localStorage.getItem("versionTime") !== response.data.version)) {
            localStorage.setItem("versionTime", response.data.version);
            //匹配本地版本缓存是否与后台返回缓存一致，如果一致说明用户已更新过版本，反之需要刷新页面
            Dialog.alert({
              message: response.data.message,
            }).then(() => {

            });
          }
      }
      if (response.data.scode == 601) {
        return
      }
      //统一处理登陆过期
      switch (response.data.code) {
        case 401:
          if (sessionStorage.getItem("uni") == "ALL") {
            setTimeout(() => {
              router.push({
                path: "/login"
              })
            }, 1000);
          } else {
            sessionStorage.removeItem("storeToken");
            sessionStorage.removeItem("token");
            setTimeout(() => {
              // login.getStoreToken();
              router.push({
                path: "/login",
                query:{
                  type:2
                }
              })
            }, 1000);
          }
          break;
        case 402:
          if (sessionStorage.getItem("uni") == "ALL") {
            setTimeout(() => {
              // login.getStoreToken();
              router.push({
                path: "/login"
              })
            }, 1000);
          } else {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("storeToken");
            setTimeout(() => {
              router.push({
                path: "/login",
                query:{
                  type:2
                }
              })
            }, 1000);
          }
          break;
          //无访问权限
        case 202:
        case 203:
        case 206:
        case 209:
          router.push({
            path:'/login',
            query:{
              type:2
            }
          });
          break;
      }
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  err => {
    console.log(err);
    // 当响应异常时做一些处理
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误(400)';
          break;
        case 401:
          err.message = '未授权，请重新登录(401)';
          break;
        case 403:
          err.message = '拒绝访问(403)';
          break;
        case 404:
          err.message = '请求出错(404)';
          break;
        case 408:
          err.message = '请求超时(408)';
          break;
        case 500:
          err.message = '服务器错误(500),请联系客服';
          break;
        case 501:
          err.message = '服务未实现(501)';
          break;
        case 502:
          err.message = '网络错误(502)';
          break;
        case 503:
          err.message = '服务不可用(503)';
          break;
        case 504:
          err.message = '网络超时(504)';
          break;
        case 505:
          err.message = 'HTTP版本不受支持(505)';
          break;
        default:
          err.message = `连接出错(${err.response.status})!`;
      }
    } else {
      //处理接口超时问题
      var config = err.config;
      // 设置本次请求是第几此
      config.__retryCount = config.__retryCount || 1;
      // 当请求超过2次后将终止请求，返回错误信息
      if (config.__retryCount >= 2) {
        //处理接口未响应
        Dialog.alert({
          message: '请求超时,请稍后重试' + '(' + JSON.parse(config.data).version + ')',
        }).then(() => {
          return Promise.reject(err);
        });
        return
      }
      // 请求次数加 1
      config.__retryCount += 1;

      // 创建一个新 promise 返回给调用接口的函数
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 1500);
      });
      // 返回 promise 返回给调用接口的函数，当到达一定时间(1000)后重新请求数据。
      return backoff.then(function () {
        return service(config);
      });
    }
    Toast({
      message: err.message,
      duration: 1500,
      forbidClick: true
    });
    return Promise.reject(err.response);
  }
)
export default service



// WEBPACK FOOTER //
// ./src/api/http.js